export default "__VITE_ASSET__a26ff7ef__"